// @flow

import React, { Component } from 'react';
import {
  HashRouter, Switch, Route, Router,
} from 'react-router-dom';
import { Flex } from '../grid';
import { TabBar, TabBarItem, TabContent } from './atoms';
import type { ACFComponentColumn } from '../../types';

type OwnProps = {|
  tabs: Array<{
    name: string,
    url: string,
    rows: Array<{
      columns: Array<ACFComponentColumn>,
    }>,
  }>,
|};

type Props = OwnProps;

type State = {| loaded: boolean |};

class Tabs extends Component<Props, State> {
  constructor() {
    super();
    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    this.setState({ // eslint-disable-line react/no-did-mount-set-state
      loaded: true,
    });
  }

  render() {
    const { tabs } = this.props;
    const { loaded } = this.state;

    if (tabs.length === 0) {
      return null;
    }

    // Before the first tick on the frontend, we render the first Tab for SEO purposes
    if (!loaded) {
      return (
        <>
          <TabBar>
            {tabs.map(({ name }) => (
              <TabBarItem
                as="div"
                key={`tab-${name}`}
                className=""
              >
                {name}
              </TabBarItem>
            ))}
          </TabBar>
          <TabContent
            rows={tabs[0].rows}
          />
        </>
      );
    }

    /**
     * We wrap a Tab in <Route>. This route always matches and grabs
     * the history of the "main" Router. Inside a tab, we wrap the content
     * of that tab with <Router history={history}>, in order to let the
     * content of the tab break out of the Hashrouter, back to the main
     * Router. This is necessary for content in the tab that contains a Link.
     */
    return (
      <Route
        render={({ history }) => (
          <HashRouter>
            <Flex flexDirection="column">
              <TabBar>
                {tabs.map(({ name, url }) => (
                  <TabBarItem
                    key={`tab-${url}`}
                    url={url}
                    className=""
                  >
                    {name}
                  </TabBarItem>
                ))}
              </TabBar>
              <Switch>
                {tabs.map(({ rows, url }) => (
                  <Route
                    exact
                    key={`row-${url}`}
                    path={url}
                    render={() => (
                      <Router history={history}>
                        <TabContent
                          rows={rows}
                        />
                      </Router>
                    )}
                  />
                ))}
              </Switch>
            </Flex>
          </HashRouter>
        )}
      />
    );
  }
}

export default Tabs;
